import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import {DataManagerService} from '../DataManager/data-manager.service';
import {HttpClient} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {catchError, mapTo, switchMap, tap} from 'rxjs/operators';
import {AppConstants} from '../../../shared/constants/app-constants';
import {isPlatformBrowser} from '@angular/common';
interface MenuItem {
  name: string;
  routes: string;
  routerLink?: string;
  subMenu?: MenuItem[] | null;
}
interface ZendeskSsoTokenRes {
  action: string;
  jwt: string;
  return_to: string;
}

@Injectable({ providedIn: 'root' })
export class ExternalLinkGuardService implements CanActivate {
  constructor(
    private http: HttpClient,
    private dataManager: DataManagerService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routePath = route.routeConfig?.path || '';     // "zendesk-knowledge" or zendesk-sso
    const fullPath = routePath.startsWith('/') ? routePath : `/${routePath}`;
    const menu = this.getMenuSafely();
    const item = this.findByRoute(menu, fullPath);
    if (routePath === 'zendesk-knowledge') {
      return this.knowlegeBase(item?.routerLink || '');
    }
    if (routePath === 'zendesk-sso') {
      // PDT-35094: the Help Center entry is hidden from the drawer in a "Login as
      // Merchant" session; also refuse a direct/history navigation so no SSO token
      // is issued for the account's service user.
      if (this.dataManager.isLoginAsMerchantSession()) {
        return of(false);
      }
      return this.knowlegeSso(item?.routerLink || '');
    }
    return of(false);
    // find matching menu item in your existing data source
    // const item = this.findByRoute(this.dataManager.menuArray as MenuItem[], full);
//     const apiUrl = `${AppConstants.BASE_URL}${item?.routerLink}`; // should point to your API endpoint
//
//     // open a blank tab synchronously to avoid popup blockers
//     const win = window.open('about:blank', '_blank');
//
//     if (!apiUrl) {
//       console.warn('[ExternalLinkGuard] Missing API url.....');
//       return of(false);
//     }
//
//     return this.dataManager.getRequest(apiUrl, 0).pipe(
//       tap((res: ZendeskSsoTokenRes) => {
//         const { action, jwt, return_to } = res;
//         const html = `
// <!doctype html><html><body onload="document.forms[0].submit()">
//   <form method="POST" action="${this.escapeHtml(action)}">
//     <input type="hidden" name="jwt" value="${this.escapeHtml(jwt)}" />
//     <input type="hidden" name="return_to" value="${this.escapeHtml(return_to)}" />
//     <noscript><button type="submit">Continue</button></noscript>
//   </form>
// </body></html>`;
//
//         if (win) {
//           win.document.open();
//           win.document.write(html);
//           win.document.close();
//         } else {
//           // Fallback: same-tab form submit if popup blocked
//           const form = document.createElement('form');
//           form.method = 'POST';
//           form.action = action;
//           form.innerHTML =
//             `<input type="hidden" name="jwt" value="${this.escapeHtml(jwt)}">` +
//             `<input type="hidden" name="return_to" value="${this.escapeHtml(return_to)}">`;
//           document.body.appendChild(form);
//           form.submit();
//         }
//       }),
//       mapTo(false), // cancel Angular navigation
//       catchError(err => {
//         try { if (win) { win.close(); } } catch {}
//         console.warn('[ExternalLinkGuard] SSO token request failed.', err);
//         return of(false);
//       })
//     );
  }

  private findByRoute(menu: MenuItem[] = [], full: string): MenuItem | null {
    const stack = [...menu];
    while (stack.length) {
      const it = stack.pop()!;
      if (!it) { break; }
      if (it.routes === full) { return it; }
      if (Array.isArray(it.subMenu)) { stack.push(...it.subMenu); }
    }
    return null;
  }

  private escapeHtml(s: string) {
    return s.replace(/[&<>"']/g, (c) =>
      ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;'} as any)[c]
    );
  }
  private knowlegeBase(routerLink?: string): Observable<boolean>{

    if (!routerLink) {
      console.warn('[ExternalLinkGuard] No external routerLink for route: knowlegeBase');
      return of(false); // cancel navigation anyway
    }
    window.open(routerLink, '_blank', 'noopener,noreferrer');
    return of(false); // cancel Angular navigation so stub never renders
  }

  private knowlegeSso(routerLink?: string): Observable<boolean> {
    if (!routerLink) {
      console.warn('[ExternalLinkGuard] No external routerLink for route: knowlegeBase');
      return of(false); // cancel navigation anyway
    }
    const apiUrl = `${AppConstants.BASE_URL}${routerLink}`; // should point to your API endpoint

    // open a blank tab synchronously to avoid popup blockers
    const win = window.open('about:blank', '_blank');

    if (!apiUrl) {
      console.warn('[ExternalLinkGuard] Missing API url.....');
      return of(false);
    }

    return this.dataManager.getRequest(apiUrl, 0).pipe(
      tap((res: ZendeskSsoTokenRes) => {
        const { action, jwt, return_to } = res;
        const html = `
<!doctype html><html><body onload="document.forms[0].submit()">
  <form method="POST" action="${this.escapeHtml(action)}">
    <input type="hidden" name="jwt" value="${this.escapeHtml(jwt)}" />
    <input type="hidden" name="return_to" value="${this.escapeHtml(return_to)}" />
    <noscript><button type="submit">Continue</button></noscript>
  </form>
</body></html>`;

        if (win) {
          win.document.open();
          win.document.write(html);
          win.document.close();
        } else {
          // Fallback: same-tab form submit if popup blocked
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = action;
          form.innerHTML =
            `<input type="hidden" name="jwt" value="${this.escapeHtml(jwt)}">` +
            `<input type="hidden" name="return_to" value="${this.escapeHtml(return_to)}">`;
          document.body.appendChild(form);
          form.submit();
        }
      }),
      mapTo(false), // cancel Angular navigation
      catchError(err => {
        try { if (win) { win.close(); } } catch {}
        console.warn('[ExternalLinkGuard] SSO token request failed.', err);
        return of(false);
      })
    );

  }
  private getMenuSafely(): MenuItem[] {
    // 1) Prefer DataManagerService (your app already holds menu here)
    const dmMenu = (this.dataManager as any)?.menuArray as MenuItem[] | undefined;
    if (Array.isArray(dmMenu) && dmMenu.length) { return dmMenu; }

    // 2) Fallback to localStorage if your bootstrap persists it
    if (isPlatformBrowser(this.platformId)) {
      // Adjust the key below to whatever you actually store the full menu under, if any.
      // If you don’t persist it, this will just return [] and the guard will no-op.
      const raw =
        localStorage.getItem((AppConstants as any).STORAGE_KEY_MENU) ||
        localStorage.getItem('menu') ||
        '';
      try {
        const parsed = raw ? JSON.parse(raw) : [];
        if (Array.isArray(parsed)) { return parsed as MenuItem[]; }
      } catch { /* ignore */ }
    }

    return [];
  }
}
